// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_pending.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { TaskSearchRequest } from "../../task/v1/search";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * Snapshot of display data at queue time
 * Note: Access review data model enforces 1 ticket = 1 selection = 1 entitlement
 *
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionSnapshot
 */
export interface PendingActionSnapshot {
    /**
     * @generated from protobuf field: string user_display_name = 1
     */
    userDisplayName: string;
    /**
     * @generated from protobuf field: string app_display_name = 2
     */
    appDisplayName: string;
    /**
     * @generated from protobuf field: string entitlement_display_name = 3
     */
    entitlementDisplayName: string; // Singular - always exactly one entitlement
    /**
     * @generated from protobuf field: string subject_display_name = 4
     */
    subjectDisplayName: string;
    /**
     * @generated from protobuf field: string subject_identifier = 5
     */
    subjectIdentifier: string;
}
/**
 * Display view of a pending action
 * Lightweight - no conflict detection (use ValidatePendingActions for that)
 *
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionView
 */
export interface PendingActionView {
    /**
     * @generated from protobuf field: string certify_task_id = 1
     */
    certifyTaskId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision decision = 2
     */
    decision: ReviewPendingDecision;
    /**
     * @generated from protobuf field: string comment = 3
     */
    comment: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp queued_at = 4
     */
    queuedAt?: Timestamp;
    /**
     * Snapshot of what reviewer saw when queuing this action
     *
     * @generated from protobuf field: c1.api.accessreview.v1.PendingActionSnapshot snapshot = 5
     */
    snapshot?: PendingActionSnapshot;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionConflict
 */
export interface PendingActionConflict {
    /**
     * @generated from protobuf field: string certify_task_id = 1
     */
    certifyTaskId: string;
    /**
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision queued_decision = 3
     */
    queuedDecision: ReviewPendingDecision;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.PendingSummary
 */
export interface PendingSummary {
    /**
     * @generated from protobuf field: int32 total_count = 1
     */
    totalCount: number;
    /**
     * @generated from protobuf field: int32 approve_count = 2
     */
    approveCount: number;
    /**
     * @generated from protobuf field: int32 deny_count = 3
     */
    denyCount: number;
    /**
     * @generated from protobuf field: int32 conflict_count = 4
     */
    conflictCount: number;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.PendingActionConflict conflicts = 5
     */
    conflicts: PendingActionConflict[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionView active_submission = 6
     */
    activeSubmission?: SubmissionView;
}
/**
 * Reference for a reviewer's pending summary.
 *
 * @generated from protobuf message c1.api.accessreview.v1.PendingSummaryRef
 */
export interface PendingSummaryRef {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2
     */
    reviewerUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.TimestampTokenView
 */
export interface TimestampTokenView {
    /**
     * @generated from protobuf field: string url = 1
     */
    url: string;
    /**
     * @generated from protobuf field: string policy_oid = 2
     */
    policyOid: string;
    /**
     * @generated from protobuf field: string serial_number = 3
     */
    serialNumber: string; // Token serial (from TST), not cert serial
    /**
     * @generated from protobuf field: google.protobuf.Timestamp generated_at = 4
     */
    generatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string tsa_fingerprint_sha256 = 5
     */
    tsaFingerprintSha256: string;
    /**
     * @generated from protobuf field: string hashed_message = 6
     */
    hashedMessage: string;
    /**
     * @generated from protobuf field: bytes tsr_der = 7
     */
    tsrDer: Uint8Array;
    /**
     * TSA certificate display fields (user-friendly, parsed)
     *
     * @generated from protobuf field: string tsa_cert_primary_name = 8
     */
    tsaCertPrimaryName: string; // Subject CN/O (first present: CN, O, organizationIdentifier, serialNumber, OU)
    /**
     * @generated from protobuf field: string tsa_cert_issuer_short = 9
     */
    tsaCertIssuerShort: string; // Issuer CN/O (first present: CN, O)
    /**
     * @generated from protobuf field: string tsa_cert_serial8 = 10
     */
    tsaCertSerial8: string; // Last 8 hex chars of cert serial
    /**
     * @generated from protobuf field: string tsa_cert_not_after_date = 11
     */
    tsaCertNotAfterDate: string; // YYYY-MM-DD (cert expiry)
    /**
     * @generated from protobuf field: string tsa_cert_ski8 = 12
     */
    tsaCertSki8: string; // First 8 hex chars of Subject Key Identifier
    /**
     * Full certificate DNs (for advanced users/debugging)
     *
     * @generated from protobuf field: string tsa_cert_subject_dn = 13
     */
    tsaCertSubjectDn: string; // Full subject DN string
    /**
     * @generated from protobuf field: string tsa_cert_issuer_dn = 14
     */
    tsaCertIssuerDn: string; // Full issuer DN string
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SignatureView
 */
export interface SignatureView {
    /**
     * @generated from protobuf field: string submission_id = 1
     */
    submissionId: string; // Signature ID = Submission ID (1:1 relationship)
    /**
     * @generated from protobuf field: string access_review_id = 2
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: string step_up_transaction_id = 4
     */
    stepUpTransactionId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp mfa_verified_at = 5
     */
    mfaVerifiedAt?: Timestamp;
    /**
     * @generated from protobuf field: string rsr_sha256 = 6
     */
    rsrSha256: string;
    /**
     * @generated from protobuf field: string rsr_download_url = 7
     */
    rsrDownloadUrl: string; // Capability URL: /file/{encrypted_token}, expires in 5 minutes
    /**
     * @generated from protobuf field: string meaning_of_signature = 8
     */
    meaningOfSignature: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct auth_context_claims = 9
     */
    authContextClaims?: Struct;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.TimestampTokenView timestamp_tokens = 10
     */
    timestampTokens: TimestampTokenView[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 11
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 total_count = 12
     */
    totalCount: number;
    /**
     * @generated from protobuf field: int32 approve_count = 13
     */
    approveCount: number;
    /**
     * @generated from protobuf field: int32 deny_count = 14
     */
    denyCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SubmissionView
 */
export interface SubmissionView {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string access_review_id = 2
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 approve_count = 4
     */
    approveCount: number;
    /**
     * @generated from protobuf field: int32 deny_count = 5
     */
    denyCount: number;
    /**
     * @generated from protobuf field: int32 total_count = 6
     */
    totalCount: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewSubmissionState state = 7
     */
    state: ReviewSubmissionState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 10
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 success_count = 11
     */
    successCount: number;
    /**
     * @generated from protobuf field: int32 error_count = 12
     */
    errorCount: number;
    /**
     * @generated from protobuf field: int32 superseded_count = 13
     */
    supersededCount: number;
    /**
     * @generated from protobuf field: string error_message = 14
     */
    errorMessage: string;
    /**
     * Signature (if campaign requires signatures) - keyed by submission.id
     *
     * @generated from protobuf field: c1.api.accessreview.v1.SignatureView signature = 15
     */
    signature?: SignatureView;
    /**
     * number of actions that were successfully processed
     *
     * @generated from protobuf field: int32 processed_approved_count = 16
     */
    processedApprovedCount: number;
    /**
     * @generated from protobuf field: int32 processed_denied_count = 17
     */
    processedDeniedCount: number;
}
/**
 * Single pending action item for upsert
 *
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionItem
 */
export interface PendingActionItem {
    /**
     * @generated from protobuf field: string certify_task_id = 1
     */
    certifyTaskId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision decision = 2
     */
    decision: ReviewPendingDecision;
    /**
     * @generated from protobuf field: string comment = 3
     */
    comment: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.UpsertPendingActionRequest
 */
export interface UpsertPendingActionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * Batch of actions to upsert (1-512 items)
     * Server fetches tasks to derive access_review_selection_id and build snapshots
     *
     * @generated from protobuf field: repeated c1.api.accessreview.v1.PendingActionItem actions = 2
     */
    actions: PendingActionItem[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.UpsertPendingActionResponse
 */
export interface UpsertPendingActionResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.PendingSummary summary = 1
     */
    summary?: PendingSummary;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.RemovePendingActionRequest
 */
export interface RemovePendingActionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * Task ID (API terminology - maps to certify_ticket_id internally)
     *
     * @generated from protobuf field: string certify_task_id = 2
     */
    certifyTaskId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.RemovePendingActionResponse
 */
export interface RemovePendingActionResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.PendingSummary summary = 1
     */
    summary?: PendingSummary;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ListPendingActionsRequest
 */
export interface ListPendingActionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision decision_filter = 4
     */
    decisionFilter: ReviewPendingDecision;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ListPendingActionsResponse
 */
export interface ListPendingActionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.PendingActionView list = 1
     */
    list: PendingActionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetPendingSummaryRequest
 */
export interface GetPendingSummaryRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetPendingSummaryResponse
 */
export interface GetPendingSummaryResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.PendingSummary summary = 1
     */
    summary?: PendingSummary;
    /**
     * @generated from protobuf field: string access_review_id = 2
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3
     */
    reviewerUserId: string;
}
// ----------------------------------------------------------------------------
// GetPendingActionsByTaskIDs
// ----------------------------------------------------------------------------

/**
 * @generated from protobuf message c1.api.accessreview.v1.GetPendingActionsByTaskIDsRequest
 */
export interface GetPendingActionsByTaskIDsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * Task IDs to look up (1-100 items)
     *
     * @generated from protobuf field: repeated string certify_task_ids = 2
     */
    certifyTaskIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetPendingActionsByTaskIDsResponse
 */
export interface GetPendingActionsByTaskIDsResponse {
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.PendingActionState> states = 1
     */
    states: {
        [key: string]: PendingActionState;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionState
 */
export interface PendingActionState {
    /**
     * @generated from protobuf oneof: state
     */
    state: {
        oneofKind: "unlocked";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.PendingActionView unlocked = 1
         */
        unlocked: PendingActionView;
    } | {
        oneofKind: "locked";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.LockedActionInfo locked = 2
         */
        locked: LockedActionInfo;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.LockedActionInfo
 */
export interface LockedActionInfo {
    /**
     * @generated from protobuf field: string submission_id = 1
     */
    submissionId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision decision = 2
     */
    decision: ReviewPendingDecision;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp queued_at = 3
     */
    queuedAt?: Timestamp;
}
// ----------------------------------------------------------------------------
// ValidatePendingActions
// ----------------------------------------------------------------------------

/**
 * @generated from protobuf message c1.api.accessreview.v1.ValidatePendingActionsRequest
 */
export interface ValidatePendingActionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * Optional: validate specific tasks (empty = validate all pending actions)
     *
     * @generated from protobuf field: repeated string certify_task_ids = 2
     */
    certifyTaskIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ValidatePendingActionsResponse
 */
export interface ValidatePendingActionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.PendingActionConflict conflicts = 1
     */
    conflicts: PendingActionConflict[];
    /**
     * @generated from protobuf field: int32 valid_count = 2
     */
    validCount: number;
    /**
     * @generated from protobuf field: int32 conflict_count = 3
     */
    conflictCount: number;
}
// ----------------------------------------------------------------------------
// DiscardAllPending
// ----------------------------------------------------------------------------

/**
 * @generated from protobuf message c1.api.accessreview.v1.DiscardAllPendingRequest
 */
export interface DiscardAllPendingRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.DiscardAllPendingResponse
 */
export interface DiscardAllPendingResponse {
    /**
     * @generated from protobuf field: int32 discarded_count = 1
     */
    discardedCount: number;
}
// ----------------------------------------------------------------------------
// DiscardPendingBySearch
// ----------------------------------------------------------------------------

/**
 * @generated from protobuf message c1.api.accessreview.v1.DiscardPendingBySearchRequest
 */
export interface DiscardPendingBySearchRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest search_request = 2
     */
    searchRequest?: TaskSearchRequest;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.DiscardPendingBySearchResponse
 */
export interface DiscardPendingBySearchResponse {
    /**
     * @generated from protobuf field: int32 discarded_count = 1
     */
    discardedCount: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.PendingSummary summary = 2
     */
    summary?: PendingSummary;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SubmitReviewRequest
 */
export interface SubmitReviewRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string step_up_transaction_id = 2
     */
    stepUpTransactionId: string;
    /**
     * @generated from protobuf field: bool acknowledge_conflicts = 3
     */
    acknowledgeConflicts: boolean;
    /**
     * @generated from protobuf field: string certify_task_id = 4
     */
    certifyTaskId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SubmitReviewResponse
 */
export interface SubmitReviewResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionAccepted submission_accepted = 1
     */
    submissionAccepted?: SubmissionAccepted;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SubmissionAccepted
 */
export interface SubmissionAccepted {
    /**
     * @generated from protobuf field: string submission_id = 1
     */
    submissionId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionView submission = 2
     */
    submission?: SubmissionView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetSubmissionStatusRequest
 */
export interface GetSubmissionStatusRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string submission_id = 2
     */
    submissionId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetSubmissionStatusResponse
 */
export interface GetSubmissionStatusResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionView submission = 1
     */
    submission?: SubmissionView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ListSubmissionsRequest
 */
export interface ListSubmissionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewSubmissionState state_filter = 4
     */
    stateFilter: ReviewSubmissionState;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ListSubmissionsResponse
 */
export interface ListSubmissionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.SubmissionView list = 1
     */
    list: SubmissionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.InitiateStepUpForSubmitRequest
 */
export interface InitiateStepUpForSubmitRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * Optional return path to redirect to after step-up auth (e.g., "/admin/campaigns" for admin view)
     *
     * @generated from protobuf field: string return_path = 2
     */
    returnPath: string;
    /**
     * @generated from protobuf field: string certify_task_id = 3
     */
    certifyTaskId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.InitiateStepUpForSubmitResponse
 */
export interface InitiateStepUpForSubmitResponse {
    /**
     * @generated from protobuf field: string submission_id = 1
     */
    submissionId: string;
    /**
     * @generated from protobuf field: string authorization_url = 3
     */
    authorizationUrl: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetLatestSubmissionRequest
 */
export interface GetLatestSubmissionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetLatestSubmissionResponse
 */
export interface GetLatestSubmissionResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SignatureView signature = 1
     */
    signature?: SignatureView;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionView submission = 2
     */
    submission?: SubmissionView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchSubmissionsRequest
 */
export interface SearchSubmissionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchSubmissionsResponse
 */
export interface SearchSubmissionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.SubmissionView list = 1
     */
    list: SubmissionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchSubmissionsByAdminRequest
 */
export interface SearchSubmissionsByAdminRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchSubmissionsByAdminResponse
 */
export interface SearchSubmissionsByAdminResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.SubmissionView list = 1
     */
    list: SubmissionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * Request to export all submissions for a campaign to CSV
 *
 * @generated from protobuf message c1.api.accessreview.v1.SubmissionsDownloadRequest
 */
export interface SubmissionsDownloadRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReviewPendingDecision
 */
export enum ReviewPendingDecision {
    /**
     * @generated from protobuf enum value: REVIEW_PENDING_DECISION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REVIEW_PENDING_DECISION_APPROVE = 1;
     */
    APPROVE = 1,
    /**
     * @generated from protobuf enum value: REVIEW_PENDING_DECISION_DENY = 2;
     */
    DENY = 2
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReviewSubmissionState
 */
export enum ReviewSubmissionState {
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_WAITING_FOR_SIGNATURE = 1;
     */
    WAITING_FOR_SIGNATURE = 1,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_PENDING = 2;
     */
    PENDING = 2,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_PROCESSING = 3;
     */
    PROCESSING = 3,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_COMPLETED = 4;
     */
    COMPLETED = 4,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_PARTIAL = 5;
     */
    PARTIAL = 5,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_ERROR = 6;
     */
    ERROR = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionSnapshot$Type extends MessageType<PendingActionSnapshot> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionSnapshot", [
            { no: 1, name: "user_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subject_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "subject_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PendingActionSnapshot>): PendingActionSnapshot {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userDisplayName = "";
        message.appDisplayName = "";
        message.entitlementDisplayName = "";
        message.subjectDisplayName = "";
        message.subjectIdentifier = "";
        if (value !== undefined)
            reflectionMergePartial<PendingActionSnapshot>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PendingActionSnapshot): PendingActionSnapshot {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_display_name */ 1:
                    message.userDisplayName = reader.string();
                    break;
                case /* string app_display_name */ 2:
                    message.appDisplayName = reader.string();
                    break;
                case /* string entitlement_display_name */ 3:
                    message.entitlementDisplayName = reader.string();
                    break;
                case /* string subject_display_name */ 4:
                    message.subjectDisplayName = reader.string();
                    break;
                case /* string subject_identifier */ 5:
                    message.subjectIdentifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PendingActionSnapshot, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_display_name = 1; */
        if (message.userDisplayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userDisplayName);
        /* string app_display_name = 2; */
        if (message.appDisplayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appDisplayName);
        /* string entitlement_display_name = 3; */
        if (message.entitlementDisplayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementDisplayName);
        /* string subject_display_name = 4; */
        if (message.subjectDisplayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.subjectDisplayName);
        /* string subject_identifier = 5; */
        if (message.subjectIdentifier !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.subjectIdentifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionSnapshot
 */
export const PendingActionSnapshot = new PendingActionSnapshot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionView$Type extends MessageType<PendingActionView> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionView", [
            { no: 1, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "decision", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"] },
            { no: 3, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "queued_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "snapshot", kind: "message", T: () => PendingActionSnapshot }
        ]);
    }
    create(value?: PartialMessage<PendingActionView>): PendingActionView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.certifyTaskId = "";
        message.decision = 0;
        message.comment = "";
        if (value !== undefined)
            reflectionMergePartial<PendingActionView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PendingActionView): PendingActionView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string certify_task_id */ 1:
                    message.certifyTaskId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ReviewPendingDecision decision */ 2:
                    message.decision = reader.int32();
                    break;
                case /* string comment */ 3:
                    message.comment = reader.string();
                    break;
                case /* google.protobuf.Timestamp queued_at */ 4:
                    message.queuedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.queuedAt);
                    break;
                case /* c1.api.accessreview.v1.PendingActionSnapshot snapshot */ 5:
                    message.snapshot = PendingActionSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.snapshot);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PendingActionView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string certify_task_id = 1; */
        if (message.certifyTaskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.certifyTaskId);
        /* c1.api.accessreview.v1.ReviewPendingDecision decision = 2; */
        if (message.decision !== 0)
            writer.tag(2, WireType.Varint).int32(message.decision);
        /* string comment = 3; */
        if (message.comment !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.comment);
        /* google.protobuf.Timestamp queued_at = 4; */
        if (message.queuedAt)
            Timestamp.internalBinaryWrite(message.queuedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.PendingActionSnapshot snapshot = 5; */
        if (message.snapshot)
            PendingActionSnapshot.internalBinaryWrite(message.snapshot, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionView
 */
export const PendingActionView = new PendingActionView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionConflict$Type extends MessageType<PendingActionConflict> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionConflict", [
            { no: 1, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "queued_decision", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"] }
        ]);
    }
    create(value?: PartialMessage<PendingActionConflict>): PendingActionConflict {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.certifyTaskId = "";
        message.reason = "";
        message.queuedDecision = 0;
        if (value !== undefined)
            reflectionMergePartial<PendingActionConflict>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PendingActionConflict): PendingActionConflict {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string certify_task_id */ 1:
                    message.certifyTaskId = reader.string();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ReviewPendingDecision queued_decision */ 3:
                    message.queuedDecision = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PendingActionConflict, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string certify_task_id = 1; */
        if (message.certifyTaskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.certifyTaskId);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        /* c1.api.accessreview.v1.ReviewPendingDecision queued_decision = 3; */
        if (message.queuedDecision !== 0)
            writer.tag(3, WireType.Varint).int32(message.queuedDecision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionConflict
 */
export const PendingActionConflict = new PendingActionConflict$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingSummary$Type extends MessageType<PendingSummary> {
    constructor() {
        super("c1.api.accessreview.v1.PendingSummary", [
            { no: 1, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "approve_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "deny_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "conflict_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "conflicts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PendingActionConflict },
            { no: 6, name: "active_submission", kind: "message", T: () => SubmissionView }
        ]);
    }
    create(value?: PartialMessage<PendingSummary>): PendingSummary {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalCount = 0;
        message.approveCount = 0;
        message.denyCount = 0;
        message.conflictCount = 0;
        message.conflicts = [];
        if (value !== undefined)
            reflectionMergePartial<PendingSummary>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PendingSummary): PendingSummary {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total_count */ 1:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 approve_count */ 2:
                    message.approveCount = reader.int32();
                    break;
                case /* int32 deny_count */ 3:
                    message.denyCount = reader.int32();
                    break;
                case /* int32 conflict_count */ 4:
                    message.conflictCount = reader.int32();
                    break;
                case /* repeated c1.api.accessreview.v1.PendingActionConflict conflicts */ 5:
                    message.conflicts.push(PendingActionConflict.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.accessreview.v1.SubmissionView active_submission */ 6:
                    message.activeSubmission = SubmissionView.internalBinaryRead(reader, reader.uint32(), options, message.activeSubmission);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PendingSummary, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 total_count = 1; */
        if (message.totalCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.totalCount);
        /* int32 approve_count = 2; */
        if (message.approveCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.approveCount);
        /* int32 deny_count = 3; */
        if (message.denyCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.denyCount);
        /* int32 conflict_count = 4; */
        if (message.conflictCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.conflictCount);
        /* repeated c1.api.accessreview.v1.PendingActionConflict conflicts = 5; */
        for (let i = 0; i < message.conflicts.length; i++)
            PendingActionConflict.internalBinaryWrite(message.conflicts[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.SubmissionView active_submission = 6; */
        if (message.activeSubmission)
            SubmissionView.internalBinaryWrite(message.activeSubmission, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingSummary
 */
export const PendingSummary = new PendingSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingSummaryRef$Type extends MessageType<PendingSummaryRef> {
    constructor() {
        super("c1.api.accessreview.v1.PendingSummaryRef", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PendingSummaryRef>): PendingSummaryRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.reviewerUserId = "";
        if (value !== undefined)
            reflectionMergePartial<PendingSummaryRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PendingSummaryRef): PendingSummaryRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 2:
                    message.reviewerUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PendingSummaryRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 2; */
        if (message.reviewerUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reviewerUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingSummaryRef
 */
export const PendingSummaryRef = new PendingSummaryRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimestampTokenView$Type extends MessageType<TimestampTokenView> {
    constructor() {
        super("c1.api.accessreview.v1.TimestampTokenView", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "policy_oid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "generated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "tsa_fingerprint_sha256", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "hashed_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "tsr_der", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 8, name: "tsa_cert_primary_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "tsa_cert_issuer_short", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "tsa_cert_serial8", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "tsa_cert_not_after_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "tsa_cert_ski8", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "tsa_cert_subject_dn", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "tsa_cert_issuer_dn", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TimestampTokenView>): TimestampTokenView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.url = "";
        message.policyOid = "";
        message.serialNumber = "";
        message.tsaFingerprintSha256 = "";
        message.hashedMessage = "";
        message.tsrDer = new Uint8Array(0);
        message.tsaCertPrimaryName = "";
        message.tsaCertIssuerShort = "";
        message.tsaCertSerial8 = "";
        message.tsaCertNotAfterDate = "";
        message.tsaCertSki8 = "";
        message.tsaCertSubjectDn = "";
        message.tsaCertIssuerDn = "";
        if (value !== undefined)
            reflectionMergePartial<TimestampTokenView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TimestampTokenView): TimestampTokenView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                case /* string policy_oid */ 2:
                    message.policyOid = reader.string();
                    break;
                case /* string serial_number */ 3:
                    message.serialNumber = reader.string();
                    break;
                case /* google.protobuf.Timestamp generated_at */ 4:
                    message.generatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.generatedAt);
                    break;
                case /* string tsa_fingerprint_sha256 */ 5:
                    message.tsaFingerprintSha256 = reader.string();
                    break;
                case /* string hashed_message */ 6:
                    message.hashedMessage = reader.string();
                    break;
                case /* bytes tsr_der */ 7:
                    message.tsrDer = reader.bytes();
                    break;
                case /* string tsa_cert_primary_name */ 8:
                    message.tsaCertPrimaryName = reader.string();
                    break;
                case /* string tsa_cert_issuer_short */ 9:
                    message.tsaCertIssuerShort = reader.string();
                    break;
                case /* string tsa_cert_serial8 */ 10:
                    message.tsaCertSerial8 = reader.string();
                    break;
                case /* string tsa_cert_not_after_date */ 11:
                    message.tsaCertNotAfterDate = reader.string();
                    break;
                case /* string tsa_cert_ski8 */ 12:
                    message.tsaCertSki8 = reader.string();
                    break;
                case /* string tsa_cert_subject_dn */ 13:
                    message.tsaCertSubjectDn = reader.string();
                    break;
                case /* string tsa_cert_issuer_dn */ 14:
                    message.tsaCertIssuerDn = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TimestampTokenView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        /* string policy_oid = 2; */
        if (message.policyOid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.policyOid);
        /* string serial_number = 3; */
        if (message.serialNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.serialNumber);
        /* google.protobuf.Timestamp generated_at = 4; */
        if (message.generatedAt)
            Timestamp.internalBinaryWrite(message.generatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string tsa_fingerprint_sha256 = 5; */
        if (message.tsaFingerprintSha256 !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tsaFingerprintSha256);
        /* string hashed_message = 6; */
        if (message.hashedMessage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.hashedMessage);
        /* bytes tsr_der = 7; */
        if (message.tsrDer.length)
            writer.tag(7, WireType.LengthDelimited).bytes(message.tsrDer);
        /* string tsa_cert_primary_name = 8; */
        if (message.tsaCertPrimaryName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.tsaCertPrimaryName);
        /* string tsa_cert_issuer_short = 9; */
        if (message.tsaCertIssuerShort !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.tsaCertIssuerShort);
        /* string tsa_cert_serial8 = 10; */
        if (message.tsaCertSerial8 !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.tsaCertSerial8);
        /* string tsa_cert_not_after_date = 11; */
        if (message.tsaCertNotAfterDate !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.tsaCertNotAfterDate);
        /* string tsa_cert_ski8 = 12; */
        if (message.tsaCertSki8 !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.tsaCertSki8);
        /* string tsa_cert_subject_dn = 13; */
        if (message.tsaCertSubjectDn !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.tsaCertSubjectDn);
        /* string tsa_cert_issuer_dn = 14; */
        if (message.tsaCertIssuerDn !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.tsaCertIssuerDn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.TimestampTokenView
 */
export const TimestampTokenView = new TimestampTokenView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SignatureView$Type extends MessageType<SignatureView> {
    constructor() {
        super("c1.api.accessreview.v1.SignatureView", [
            { no: 1, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "step_up_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "mfa_verified_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "rsr_sha256", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "rsr_download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "meaning_of_signature", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "auth_context_claims", kind: "message", T: () => Struct },
            { no: 10, name: "timestamp_tokens", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimestampTokenView },
            { no: 11, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "approve_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "deny_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SignatureView>): SignatureView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.submissionId = "";
        message.accessReviewId = "";
        message.reviewerUserId = "";
        message.stepUpTransactionId = "";
        message.rsrSha256 = "";
        message.rsrDownloadUrl = "";
        message.meaningOfSignature = "";
        message.timestampTokens = [];
        message.totalCount = 0;
        message.approveCount = 0;
        message.denyCount = 0;
        if (value !== undefined)
            reflectionMergePartial<SignatureView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SignatureView): SignatureView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string submission_id */ 1:
                    message.submissionId = reader.string();
                    break;
                case /* string access_review_id */ 2:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 3:
                    message.reviewerUserId = reader.string();
                    break;
                case /* string step_up_transaction_id */ 4:
                    message.stepUpTransactionId = reader.string();
                    break;
                case /* google.protobuf.Timestamp mfa_verified_at */ 5:
                    message.mfaVerifiedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.mfaVerifiedAt);
                    break;
                case /* string rsr_sha256 */ 6:
                    message.rsrSha256 = reader.string();
                    break;
                case /* string rsr_download_url */ 7:
                    message.rsrDownloadUrl = reader.string();
                    break;
                case /* string meaning_of_signature */ 8:
                    message.meaningOfSignature = reader.string();
                    break;
                case /* google.protobuf.Struct auth_context_claims */ 9:
                    message.authContextClaims = Struct.internalBinaryRead(reader, reader.uint32(), options, message.authContextClaims);
                    break;
                case /* repeated c1.api.accessreview.v1.TimestampTokenView timestamp_tokens */ 10:
                    message.timestampTokens.push(TimestampTokenView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp created_at */ 11:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* int32 total_count */ 12:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 approve_count */ 13:
                    message.approveCount = reader.int32();
                    break;
                case /* int32 deny_count */ 14:
                    message.denyCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SignatureView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string submission_id = 1; */
        if (message.submissionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.submissionId);
        /* string access_review_id = 2; */
        if (message.accessReviewId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 3; */
        if (message.reviewerUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reviewerUserId);
        /* string step_up_transaction_id = 4; */
        if (message.stepUpTransactionId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.stepUpTransactionId);
        /* google.protobuf.Timestamp mfa_verified_at = 5; */
        if (message.mfaVerifiedAt)
            Timestamp.internalBinaryWrite(message.mfaVerifiedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string rsr_sha256 = 6; */
        if (message.rsrSha256 !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.rsrSha256);
        /* string rsr_download_url = 7; */
        if (message.rsrDownloadUrl !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.rsrDownloadUrl);
        /* string meaning_of_signature = 8; */
        if (message.meaningOfSignature !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.meaningOfSignature);
        /* google.protobuf.Struct auth_context_claims = 9; */
        if (message.authContextClaims)
            Struct.internalBinaryWrite(message.authContextClaims, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.TimestampTokenView timestamp_tokens = 10; */
        for (let i = 0; i < message.timestampTokens.length; i++)
            TimestampTokenView.internalBinaryWrite(message.timestampTokens[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 11; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 12; */
        if (message.totalCount !== 0)
            writer.tag(12, WireType.Varint).int32(message.totalCount);
        /* int32 approve_count = 13; */
        if (message.approveCount !== 0)
            writer.tag(13, WireType.Varint).int32(message.approveCount);
        /* int32 deny_count = 14; */
        if (message.denyCount !== 0)
            writer.tag(14, WireType.Varint).int32(message.denyCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SignatureView
 */
export const SignatureView = new SignatureView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmissionView$Type extends MessageType<SubmissionView> {
    constructor() {
        super("c1.api.accessreview.v1.SubmissionView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "approve_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "deny_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "state", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewSubmissionState", ReviewSubmissionState, "REVIEW_SUBMISSION_STATE_"] },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "completed_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "success_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "error_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "superseded_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "signature", kind: "message", T: () => SignatureView },
            { no: 16, name: "processed_approved_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "processed_denied_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SubmissionView>): SubmissionView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.accessReviewId = "";
        message.reviewerUserId = "";
        message.approveCount = 0;
        message.denyCount = 0;
        message.totalCount = 0;
        message.state = 0;
        message.successCount = 0;
        message.errorCount = 0;
        message.supersededCount = 0;
        message.errorMessage = "";
        message.processedApprovedCount = 0;
        message.processedDeniedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<SubmissionView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubmissionView): SubmissionView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string access_review_id */ 2:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 3:
                    message.reviewerUserId = reader.string();
                    break;
                case /* int32 approve_count */ 4:
                    message.approveCount = reader.int32();
                    break;
                case /* int32 deny_count */ 5:
                    message.denyCount = reader.int32();
                    break;
                case /* int32 total_count */ 6:
                    message.totalCount = reader.int32();
                    break;
                case /* c1.api.accessreview.v1.ReviewSubmissionState state */ 7:
                    message.state = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 8:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 9:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 10:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* int32 success_count */ 11:
                    message.successCount = reader.int32();
                    break;
                case /* int32 error_count */ 12:
                    message.errorCount = reader.int32();
                    break;
                case /* int32 superseded_count */ 13:
                    message.supersededCount = reader.int32();
                    break;
                case /* string error_message */ 14:
                    message.errorMessage = reader.string();
                    break;
                case /* c1.api.accessreview.v1.SignatureView signature */ 15:
                    message.signature = SignatureView.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                case /* int32 processed_approved_count */ 16:
                    message.processedApprovedCount = reader.int32();
                    break;
                case /* int32 processed_denied_count */ 17:
                    message.processedDeniedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubmissionView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string access_review_id = 2; */
        if (message.accessReviewId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 3; */
        if (message.reviewerUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reviewerUserId);
        /* int32 approve_count = 4; */
        if (message.approveCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.approveCount);
        /* int32 deny_count = 5; */
        if (message.denyCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.denyCount);
        /* int32 total_count = 6; */
        if (message.totalCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.totalCount);
        /* c1.api.accessreview.v1.ReviewSubmissionState state = 7; */
        if (message.state !== 0)
            writer.tag(7, WireType.Varint).int32(message.state);
        /* google.protobuf.Timestamp created_at = 8; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 9; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 10; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* int32 success_count = 11; */
        if (message.successCount !== 0)
            writer.tag(11, WireType.Varint).int32(message.successCount);
        /* int32 error_count = 12; */
        if (message.errorCount !== 0)
            writer.tag(12, WireType.Varint).int32(message.errorCount);
        /* int32 superseded_count = 13; */
        if (message.supersededCount !== 0)
            writer.tag(13, WireType.Varint).int32(message.supersededCount);
        /* string error_message = 14; */
        if (message.errorMessage !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.errorMessage);
        /* c1.api.accessreview.v1.SignatureView signature = 15; */
        if (message.signature)
            SignatureView.internalBinaryWrite(message.signature, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* int32 processed_approved_count = 16; */
        if (message.processedApprovedCount !== 0)
            writer.tag(16, WireType.Varint).int32(message.processedApprovedCount);
        /* int32 processed_denied_count = 17; */
        if (message.processedDeniedCount !== 0)
            writer.tag(17, WireType.Varint).int32(message.processedDeniedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmissionView
 */
export const SubmissionView = new SubmissionView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionItem$Type extends MessageType<PendingActionItem> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionItem", [
            { no: 1, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "decision", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"], options: { "validate.rules": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<PendingActionItem>): PendingActionItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.certifyTaskId = "";
        message.decision = 0;
        message.comment = "";
        if (value !== undefined)
            reflectionMergePartial<PendingActionItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PendingActionItem): PendingActionItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string certify_task_id */ 1:
                    message.certifyTaskId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ReviewPendingDecision decision */ 2:
                    message.decision = reader.int32();
                    break;
                case /* string comment */ 3:
                    message.comment = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PendingActionItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string certify_task_id = 1; */
        if (message.certifyTaskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.certifyTaskId);
        /* c1.api.accessreview.v1.ReviewPendingDecision decision = 2; */
        if (message.decision !== 0)
            writer.tag(2, WireType.Varint).int32(message.decision);
        /* string comment = 3; */
        if (message.comment !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.comment);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionItem
 */
export const PendingActionItem = new PendingActionItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertPendingActionRequest$Type extends MessageType<UpsertPendingActionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.UpsertPendingActionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "actions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PendingActionItem, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<UpsertPendingActionRequest>): UpsertPendingActionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.actions = [];
        if (value !== undefined)
            reflectionMergePartial<UpsertPendingActionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertPendingActionRequest): UpsertPendingActionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.PendingActionItem actions */ 2:
                    message.actions.push(PendingActionItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpsertPendingActionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* repeated c1.api.accessreview.v1.PendingActionItem actions = 2; */
        for (let i = 0; i < message.actions.length; i++)
            PendingActionItem.internalBinaryWrite(message.actions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.UpsertPendingActionRequest
 */
export const UpsertPendingActionRequest = new UpsertPendingActionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertPendingActionResponse$Type extends MessageType<UpsertPendingActionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.UpsertPendingActionResponse", [
            { no: 1, name: "summary", kind: "message", T: () => PendingSummary }
        ]);
    }
    create(value?: PartialMessage<UpsertPendingActionResponse>): UpsertPendingActionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpsertPendingActionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertPendingActionResponse): UpsertPendingActionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.PendingSummary summary */ 1:
                    message.summary = PendingSummary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpsertPendingActionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.PendingSummary summary = 1; */
        if (message.summary)
            PendingSummary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.UpsertPendingActionResponse
 */
export const UpsertPendingActionResponse = new UpsertPendingActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemovePendingActionRequest$Type extends MessageType<RemovePendingActionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.RemovePendingActionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RemovePendingActionRequest>): RemovePendingActionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.certifyTaskId = "";
        if (value !== undefined)
            reflectionMergePartial<RemovePendingActionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemovePendingActionRequest): RemovePendingActionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string certify_task_id */ 2:
                    message.certifyTaskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemovePendingActionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string certify_task_id = 2; */
        if (message.certifyTaskId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.certifyTaskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.RemovePendingActionRequest
 */
export const RemovePendingActionRequest = new RemovePendingActionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemovePendingActionResponse$Type extends MessageType<RemovePendingActionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.RemovePendingActionResponse", [
            { no: 1, name: "summary", kind: "message", T: () => PendingSummary }
        ]);
    }
    create(value?: PartialMessage<RemovePendingActionResponse>): RemovePendingActionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemovePendingActionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemovePendingActionResponse): RemovePendingActionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.PendingSummary summary */ 1:
                    message.summary = PendingSummary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemovePendingActionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.PendingSummary summary = 1; */
        if (message.summary)
            PendingSummary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.RemovePendingActionResponse
 */
export const RemovePendingActionResponse = new RemovePendingActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPendingActionsRequest$Type extends MessageType<ListPendingActionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.ListPendingActionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 250, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "decision_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"], options: { "validate.rules": { enum: { definedOnly: true } } } }
        ]);
    }
    create(value?: PartialMessage<ListPendingActionsRequest>): ListPendingActionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.decisionFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<ListPendingActionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPendingActionsRequest): ListPendingActionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ReviewPendingDecision decision_filter */ 4:
                    message.decisionFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPendingActionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.ReviewPendingDecision decision_filter = 4; */
        if (message.decisionFilter !== 0)
            writer.tag(4, WireType.Varint).int32(message.decisionFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ListPendingActionsRequest
 */
export const ListPendingActionsRequest = new ListPendingActionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPendingActionsResponse$Type extends MessageType<ListPendingActionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.ListPendingActionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PendingActionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListPendingActionsResponse>): ListPendingActionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListPendingActionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPendingActionsResponse): ListPendingActionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.PendingActionView list */ 1:
                    message.list.push(PendingActionView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPendingActionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.PendingActionView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PendingActionView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ListPendingActionsResponse
 */
export const ListPendingActionsResponse = new ListPendingActionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPendingSummaryRequest$Type extends MessageType<GetPendingSummaryRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetPendingSummaryRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetPendingSummaryRequest>): GetPendingSummaryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<GetPendingSummaryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPendingSummaryRequest): GetPendingSummaryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPendingSummaryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetPendingSummaryRequest
 */
export const GetPendingSummaryRequest = new GetPendingSummaryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPendingSummaryResponse$Type extends MessageType<GetPendingSummaryResponse> {
    constructor() {
        super("c1.api.accessreview.v1.GetPendingSummaryResponse", [
            { no: 1, name: "summary", kind: "message", T: () => PendingSummary },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetPendingSummaryResponse>): GetPendingSummaryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.reviewerUserId = "";
        if (value !== undefined)
            reflectionMergePartial<GetPendingSummaryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPendingSummaryResponse): GetPendingSummaryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.PendingSummary summary */ 1:
                    message.summary = PendingSummary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                case /* string access_review_id */ 2:
                    message.accessReviewId = reader.string();
                    break;
                case /* string reviewer_user_id */ 3:
                    message.reviewerUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPendingSummaryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.PendingSummary summary = 1; */
        if (message.summary)
            PendingSummary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string access_review_id = 2; */
        if (message.accessReviewId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewId);
        /* string reviewer_user_id = 3; */
        if (message.reviewerUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reviewerUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetPendingSummaryResponse
 */
export const GetPendingSummaryResponse = new GetPendingSummaryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPendingActionsByTaskIDsRequest$Type extends MessageType<GetPendingActionsByTaskIDsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetPendingActionsByTaskIDsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "certify_task_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<GetPendingActionsByTaskIDsRequest>): GetPendingActionsByTaskIDsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.certifyTaskIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetPendingActionsByTaskIDsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPendingActionsByTaskIDsRequest): GetPendingActionsByTaskIDsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* repeated string certify_task_ids */ 2:
                    message.certifyTaskIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPendingActionsByTaskIDsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* repeated string certify_task_ids = 2; */
        for (let i = 0; i < message.certifyTaskIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.certifyTaskIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetPendingActionsByTaskIDsRequest
 */
export const GetPendingActionsByTaskIDsRequest = new GetPendingActionsByTaskIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPendingActionsByTaskIDsResponse$Type extends MessageType<GetPendingActionsByTaskIDsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.GetPendingActionsByTaskIDsResponse", [
            { no: 1, name: "states", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => PendingActionState } }
        ]);
    }
    create(value?: PartialMessage<GetPendingActionsByTaskIDsResponse>): GetPendingActionsByTaskIDsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.states = {};
        if (value !== undefined)
            reflectionMergePartial<GetPendingActionsByTaskIDsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPendingActionsByTaskIDsResponse): GetPendingActionsByTaskIDsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, c1.api.accessreview.v1.PendingActionState> states */ 1:
                    this.binaryReadMap1(message.states, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: GetPendingActionsByTaskIDsResponse["states"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetPendingActionsByTaskIDsResponse["states"] | undefined, val: GetPendingActionsByTaskIDsResponse["states"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = PendingActionState.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.accessreview.v1.GetPendingActionsByTaskIDsResponse.states");
            }
        }
        map[key ?? ""] = val ?? PendingActionState.create();
    }
    internalBinaryWrite(message: GetPendingActionsByTaskIDsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, c1.api.accessreview.v1.PendingActionState> states = 1; */
        for (let k of globalThis.Object.keys(message.states)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            PendingActionState.internalBinaryWrite(message.states[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetPendingActionsByTaskIDsResponse
 */
export const GetPendingActionsByTaskIDsResponse = new GetPendingActionsByTaskIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionState$Type extends MessageType<PendingActionState> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionState", [
            { no: 1, name: "unlocked", kind: "message", oneof: "state", T: () => PendingActionView },
            { no: 2, name: "locked", kind: "message", oneof: "state", T: () => LockedActionInfo }
        ]);
    }
    create(value?: PartialMessage<PendingActionState>): PendingActionState {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.state = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<PendingActionState>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PendingActionState): PendingActionState {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.PendingActionView unlocked */ 1:
                    message.state = {
                        oneofKind: "unlocked",
                        unlocked: PendingActionView.internalBinaryRead(reader, reader.uint32(), options, (message.state as any).unlocked)
                    };
                    break;
                case /* c1.api.accessreview.v1.LockedActionInfo locked */ 2:
                    message.state = {
                        oneofKind: "locked",
                        locked: LockedActionInfo.internalBinaryRead(reader, reader.uint32(), options, (message.state as any).locked)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PendingActionState, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.PendingActionView unlocked = 1; */
        if (message.state.oneofKind === "unlocked")
            PendingActionView.internalBinaryWrite(message.state.unlocked, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.LockedActionInfo locked = 2; */
        if (message.state.oneofKind === "locked")
            LockedActionInfo.internalBinaryWrite(message.state.locked, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionState
 */
export const PendingActionState = new PendingActionState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LockedActionInfo$Type extends MessageType<LockedActionInfo> {
    constructor() {
        super("c1.api.accessreview.v1.LockedActionInfo", [
            { no: 1, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "decision", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"] },
            { no: 3, name: "queued_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<LockedActionInfo>): LockedActionInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.submissionId = "";
        message.decision = 0;
        if (value !== undefined)
            reflectionMergePartial<LockedActionInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LockedActionInfo): LockedActionInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string submission_id */ 1:
                    message.submissionId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ReviewPendingDecision decision */ 2:
                    message.decision = reader.int32();
                    break;
                case /* google.protobuf.Timestamp queued_at */ 3:
                    message.queuedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.queuedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LockedActionInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string submission_id = 1; */
        if (message.submissionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.submissionId);
        /* c1.api.accessreview.v1.ReviewPendingDecision decision = 2; */
        if (message.decision !== 0)
            writer.tag(2, WireType.Varint).int32(message.decision);
        /* google.protobuf.Timestamp queued_at = 3; */
        if (message.queuedAt)
            Timestamp.internalBinaryWrite(message.queuedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.LockedActionInfo
 */
export const LockedActionInfo = new LockedActionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidatePendingActionsRequest$Type extends MessageType<ValidatePendingActionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.ValidatePendingActionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "certify_task_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "512", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ValidatePendingActionsRequest>): ValidatePendingActionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.certifyTaskIds = [];
        if (value !== undefined)
            reflectionMergePartial<ValidatePendingActionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidatePendingActionsRequest): ValidatePendingActionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* repeated string certify_task_ids */ 2:
                    message.certifyTaskIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidatePendingActionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* repeated string certify_task_ids = 2; */
        for (let i = 0; i < message.certifyTaskIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.certifyTaskIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ValidatePendingActionsRequest
 */
export const ValidatePendingActionsRequest = new ValidatePendingActionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidatePendingActionsResponse$Type extends MessageType<ValidatePendingActionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.ValidatePendingActionsResponse", [
            { no: 1, name: "conflicts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PendingActionConflict },
            { no: 2, name: "valid_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "conflict_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ValidatePendingActionsResponse>): ValidatePendingActionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conflicts = [];
        message.validCount = 0;
        message.conflictCount = 0;
        if (value !== undefined)
            reflectionMergePartial<ValidatePendingActionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidatePendingActionsResponse): ValidatePendingActionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.PendingActionConflict conflicts */ 1:
                    message.conflicts.push(PendingActionConflict.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 valid_count */ 2:
                    message.validCount = reader.int32();
                    break;
                case /* int32 conflict_count */ 3:
                    message.conflictCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidatePendingActionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.PendingActionConflict conflicts = 1; */
        for (let i = 0; i < message.conflicts.length; i++)
            PendingActionConflict.internalBinaryWrite(message.conflicts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 valid_count = 2; */
        if (message.validCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.validCount);
        /* int32 conflict_count = 3; */
        if (message.conflictCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.conflictCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ValidatePendingActionsResponse
 */
export const ValidatePendingActionsResponse = new ValidatePendingActionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscardAllPendingRequest$Type extends MessageType<DiscardAllPendingRequest> {
    constructor() {
        super("c1.api.accessreview.v1.DiscardAllPendingRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DiscardAllPendingRequest>): DiscardAllPendingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<DiscardAllPendingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DiscardAllPendingRequest): DiscardAllPendingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DiscardAllPendingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.DiscardAllPendingRequest
 */
export const DiscardAllPendingRequest = new DiscardAllPendingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscardAllPendingResponse$Type extends MessageType<DiscardAllPendingResponse> {
    constructor() {
        super("c1.api.accessreview.v1.DiscardAllPendingResponse", [
            { no: 1, name: "discarded_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<DiscardAllPendingResponse>): DiscardAllPendingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.discardedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<DiscardAllPendingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DiscardAllPendingResponse): DiscardAllPendingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 discarded_count */ 1:
                    message.discardedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DiscardAllPendingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 discarded_count = 1; */
        if (message.discardedCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.discardedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.DiscardAllPendingResponse
 */
export const DiscardAllPendingResponse = new DiscardAllPendingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscardPendingBySearchRequest$Type extends MessageType<DiscardPendingBySearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.DiscardPendingBySearchRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "search_request", kind: "message", T: () => TaskSearchRequest, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
    create(value?: PartialMessage<DiscardPendingBySearchRequest>): DiscardPendingBySearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<DiscardPendingBySearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DiscardPendingBySearchRequest): DiscardPendingBySearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskSearchRequest search_request */ 2:
                    message.searchRequest = TaskSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.searchRequest);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DiscardPendingBySearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.task.v1.TaskSearchRequest search_request = 2; */
        if (message.searchRequest)
            TaskSearchRequest.internalBinaryWrite(message.searchRequest, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.DiscardPendingBySearchRequest
 */
export const DiscardPendingBySearchRequest = new DiscardPendingBySearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscardPendingBySearchResponse$Type extends MessageType<DiscardPendingBySearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.DiscardPendingBySearchResponse", [
            { no: 1, name: "discarded_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "summary", kind: "message", T: () => PendingSummary }
        ]);
    }
    create(value?: PartialMessage<DiscardPendingBySearchResponse>): DiscardPendingBySearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.discardedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<DiscardPendingBySearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DiscardPendingBySearchResponse): DiscardPendingBySearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 discarded_count */ 1:
                    message.discardedCount = reader.int32();
                    break;
                case /* c1.api.accessreview.v1.PendingSummary summary */ 2:
                    message.summary = PendingSummary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DiscardPendingBySearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 discarded_count = 1; */
        if (message.discardedCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.discardedCount);
        /* c1.api.accessreview.v1.PendingSummary summary = 2; */
        if (message.summary)
            PendingSummary.internalBinaryWrite(message.summary, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.DiscardPendingBySearchResponse
 */
export const DiscardPendingBySearchResponse = new DiscardPendingBySearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitReviewRequest$Type extends MessageType<SubmitReviewRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SubmitReviewRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "step_up_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "acknowledge_conflicts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<SubmitReviewRequest>): SubmitReviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.stepUpTransactionId = "";
        message.acknowledgeConflicts = false;
        message.certifyTaskId = "";
        if (value !== undefined)
            reflectionMergePartial<SubmitReviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubmitReviewRequest): SubmitReviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string step_up_transaction_id */ 2:
                    message.stepUpTransactionId = reader.string();
                    break;
                case /* bool acknowledge_conflicts */ 3:
                    message.acknowledgeConflicts = reader.bool();
                    break;
                case /* string certify_task_id */ 4:
                    message.certifyTaskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubmitReviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string step_up_transaction_id = 2; */
        if (message.stepUpTransactionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stepUpTransactionId);
        /* bool acknowledge_conflicts = 3; */
        if (message.acknowledgeConflicts !== false)
            writer.tag(3, WireType.Varint).bool(message.acknowledgeConflicts);
        /* string certify_task_id = 4; */
        if (message.certifyTaskId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.certifyTaskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmitReviewRequest
 */
export const SubmitReviewRequest = new SubmitReviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitReviewResponse$Type extends MessageType<SubmitReviewResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SubmitReviewResponse", [
            { no: 1, name: "submission_accepted", kind: "message", T: () => SubmissionAccepted }
        ]);
    }
    create(value?: PartialMessage<SubmitReviewResponse>): SubmitReviewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SubmitReviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubmitReviewResponse): SubmitReviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.SubmissionAccepted submission_accepted */ 1:
                    message.submissionAccepted = SubmissionAccepted.internalBinaryRead(reader, reader.uint32(), options, message.submissionAccepted);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubmitReviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.SubmissionAccepted submission_accepted = 1; */
        if (message.submissionAccepted)
            SubmissionAccepted.internalBinaryWrite(message.submissionAccepted, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmitReviewResponse
 */
export const SubmitReviewResponse = new SubmitReviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmissionAccepted$Type extends MessageType<SubmissionAccepted> {
    constructor() {
        super("c1.api.accessreview.v1.SubmissionAccepted", [
            { no: 1, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "submission", kind: "message", T: () => SubmissionView }
        ]);
    }
    create(value?: PartialMessage<SubmissionAccepted>): SubmissionAccepted {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.submissionId = "";
        if (value !== undefined)
            reflectionMergePartial<SubmissionAccepted>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubmissionAccepted): SubmissionAccepted {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string submission_id */ 1:
                    message.submissionId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.SubmissionView submission */ 2:
                    message.submission = SubmissionView.internalBinaryRead(reader, reader.uint32(), options, message.submission);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubmissionAccepted, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string submission_id = 1; */
        if (message.submissionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.submissionId);
        /* c1.api.accessreview.v1.SubmissionView submission = 2; */
        if (message.submission)
            SubmissionView.internalBinaryWrite(message.submission, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmissionAccepted
 */
export const SubmissionAccepted = new SubmissionAccepted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSubmissionStatusRequest$Type extends MessageType<GetSubmissionStatusRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetSubmissionStatusRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetSubmissionStatusRequest>): GetSubmissionStatusRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.submissionId = "";
        if (value !== undefined)
            reflectionMergePartial<GetSubmissionStatusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSubmissionStatusRequest): GetSubmissionStatusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string submission_id */ 2:
                    message.submissionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSubmissionStatusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string submission_id = 2; */
        if (message.submissionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.submissionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetSubmissionStatusRequest
 */
export const GetSubmissionStatusRequest = new GetSubmissionStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSubmissionStatusResponse$Type extends MessageType<GetSubmissionStatusResponse> {
    constructor() {
        super("c1.api.accessreview.v1.GetSubmissionStatusResponse", [
            { no: 1, name: "submission", kind: "message", T: () => SubmissionView }
        ]);
    }
    create(value?: PartialMessage<GetSubmissionStatusResponse>): GetSubmissionStatusResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSubmissionStatusResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSubmissionStatusResponse): GetSubmissionStatusResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.SubmissionView submission */ 1:
                    message.submission = SubmissionView.internalBinaryRead(reader, reader.uint32(), options, message.submission);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSubmissionStatusResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.SubmissionView submission = 1; */
        if (message.submission)
            SubmissionView.internalBinaryWrite(message.submission, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetSubmissionStatusResponse
 */
export const GetSubmissionStatusResponse = new GetSubmissionStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSubmissionsRequest$Type extends MessageType<ListSubmissionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.ListSubmissionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "state_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewSubmissionState", ReviewSubmissionState, "REVIEW_SUBMISSION_STATE_"] }
        ]);
    }
    create(value?: PartialMessage<ListSubmissionsRequest>): ListSubmissionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.stateFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<ListSubmissionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSubmissionsRequest): ListSubmissionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ReviewSubmissionState state_filter */ 4:
                    message.stateFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSubmissionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.ReviewSubmissionState state_filter = 4; */
        if (message.stateFilter !== 0)
            writer.tag(4, WireType.Varint).int32(message.stateFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ListSubmissionsRequest
 */
export const ListSubmissionsRequest = new ListSubmissionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSubmissionsResponse$Type extends MessageType<ListSubmissionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.ListSubmissionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubmissionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListSubmissionsResponse>): ListSubmissionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListSubmissionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSubmissionsResponse): ListSubmissionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.SubmissionView list */ 1:
                    message.list.push(SubmissionView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSubmissionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.SubmissionView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            SubmissionView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ListSubmissionsResponse
 */
export const ListSubmissionsResponse = new ListSubmissionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitiateStepUpForSubmitRequest$Type extends MessageType<InitiateStepUpForSubmitRequest> {
    constructor() {
        super("c1.api.accessreview.v1.InitiateStepUpForSubmitRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "return_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<InitiateStepUpForSubmitRequest>): InitiateStepUpForSubmitRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.returnPath = "";
        message.certifyTaskId = "";
        if (value !== undefined)
            reflectionMergePartial<InitiateStepUpForSubmitRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InitiateStepUpForSubmitRequest): InitiateStepUpForSubmitRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string return_path */ 2:
                    message.returnPath = reader.string();
                    break;
                case /* string certify_task_id */ 3:
                    message.certifyTaskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InitiateStepUpForSubmitRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string return_path = 2; */
        if (message.returnPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.returnPath);
        /* string certify_task_id = 3; */
        if (message.certifyTaskId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.certifyTaskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.InitiateStepUpForSubmitRequest
 */
export const InitiateStepUpForSubmitRequest = new InitiateStepUpForSubmitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitiateStepUpForSubmitResponse$Type extends MessageType<InitiateStepUpForSubmitResponse> {
    constructor() {
        super("c1.api.accessreview.v1.InitiateStepUpForSubmitResponse", [
            { no: 1, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "authorization_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<InitiateStepUpForSubmitResponse>): InitiateStepUpForSubmitResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.submissionId = "";
        message.authorizationUrl = "";
        if (value !== undefined)
            reflectionMergePartial<InitiateStepUpForSubmitResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InitiateStepUpForSubmitResponse): InitiateStepUpForSubmitResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string submission_id */ 1:
                    message.submissionId = reader.string();
                    break;
                case /* string authorization_url */ 3:
                    message.authorizationUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InitiateStepUpForSubmitResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string submission_id = 1; */
        if (message.submissionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.submissionId);
        /* string authorization_url = 3; */
        if (message.authorizationUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.authorizationUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.InitiateStepUpForSubmitResponse
 */
export const InitiateStepUpForSubmitResponse = new InitiateStepUpForSubmitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestSubmissionRequest$Type extends MessageType<GetLatestSubmissionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetLatestSubmissionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetLatestSubmissionRequest>): GetLatestSubmissionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<GetLatestSubmissionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLatestSubmissionRequest): GetLatestSubmissionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLatestSubmissionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetLatestSubmissionRequest
 */
export const GetLatestSubmissionRequest = new GetLatestSubmissionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestSubmissionResponse$Type extends MessageType<GetLatestSubmissionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.GetLatestSubmissionResponse", [
            { no: 1, name: "signature", kind: "message", T: () => SignatureView },
            { no: 2, name: "submission", kind: "message", T: () => SubmissionView }
        ]);
    }
    create(value?: PartialMessage<GetLatestSubmissionResponse>): GetLatestSubmissionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLatestSubmissionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLatestSubmissionResponse): GetLatestSubmissionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.SignatureView signature */ 1:
                    message.signature = SignatureView.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                case /* c1.api.accessreview.v1.SubmissionView submission */ 2:
                    message.submission = SubmissionView.internalBinaryRead(reader, reader.uint32(), options, message.submission);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLatestSubmissionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.SignatureView signature = 1; */
        if (message.signature)
            SignatureView.internalBinaryWrite(message.signature, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.SubmissionView submission = 2; */
        if (message.submission)
            SubmissionView.internalBinaryWrite(message.submission, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetLatestSubmissionResponse
 */
export const GetLatestSubmissionResponse = new GetLatestSubmissionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSubmissionsRequest$Type extends MessageType<SearchSubmissionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SearchSubmissionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchSubmissionsRequest>): SearchSubmissionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchSubmissionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSubmissionsRequest): SearchSubmissionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSubmissionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchSubmissionsRequest
 */
export const SearchSubmissionsRequest = new SearchSubmissionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSubmissionsResponse$Type extends MessageType<SearchSubmissionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SearchSubmissionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubmissionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchSubmissionsResponse>): SearchSubmissionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchSubmissionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSubmissionsResponse): SearchSubmissionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.SubmissionView list */ 1:
                    message.list.push(SubmissionView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSubmissionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.SubmissionView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            SubmissionView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchSubmissionsResponse
 */
export const SearchSubmissionsResponse = new SearchSubmissionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSubmissionsByAdminRequest$Type extends MessageType<SearchSubmissionsByAdminRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SearchSubmissionsByAdminRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchSubmissionsByAdminRequest>): SearchSubmissionsByAdminRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchSubmissionsByAdminRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSubmissionsByAdminRequest): SearchSubmissionsByAdminRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSubmissionsByAdminRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchSubmissionsByAdminRequest
 */
export const SearchSubmissionsByAdminRequest = new SearchSubmissionsByAdminRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSubmissionsByAdminResponse$Type extends MessageType<SearchSubmissionsByAdminResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SearchSubmissionsByAdminResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubmissionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchSubmissionsByAdminResponse>): SearchSubmissionsByAdminResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchSubmissionsByAdminResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSubmissionsByAdminResponse): SearchSubmissionsByAdminResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.SubmissionView list */ 1:
                    message.list.push(SubmissionView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSubmissionsByAdminResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.SubmissionView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            SubmissionView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchSubmissionsByAdminResponse
 */
export const SearchSubmissionsByAdminResponse = new SearchSubmissionsByAdminResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmissionsDownloadRequest$Type extends MessageType<SubmissionsDownloadRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SubmissionsDownloadRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<SubmissionsDownloadRequest>): SubmissionsDownloadRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<SubmissionsDownloadRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubmissionsDownloadRequest): SubmissionsDownloadRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubmissionsDownloadRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmissionsDownloadRequest
 */
export const SubmissionsDownloadRequest = new SubmissionsDownloadRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewPendingActionsService
 */
export const AccessReviewPendingActionsService = new ServiceType("c1.api.accessreview.v1.AccessReviewPendingActionsService", [
    { name: "UpsertPendingAction", options: { "authz.method": { role: "EDITOR" } }, I: UpsertPendingActionRequest, O: UpsertPendingActionResponse },
    { name: "RemovePendingAction", options: { "authz.method": { role: "EDITOR" } }, I: RemovePendingActionRequest, O: RemovePendingActionResponse },
    { name: "ListPendingActions", options: { "authz.method": { role: "EDITOR" } }, I: ListPendingActionsRequest, O: ListPendingActionsResponse },
    { name: "GetPendingSummary", options: { "authz.method": { role: "EDITOR" } }, I: GetPendingSummaryRequest, O: GetPendingSummaryResponse },
    { name: "GetPendingActionsByTaskIDs", options: { "authz.method": { role: "EDITOR" } }, I: GetPendingActionsByTaskIDsRequest, O: GetPendingActionsByTaskIDsResponse },
    { name: "ValidatePendingActions", options: { "authz.method": { role: "EDITOR" } }, I: ValidatePendingActionsRequest, O: ValidatePendingActionsResponse },
    { name: "DiscardAllPending", options: { "authz.method": { role: "EDITOR" } }, I: DiscardAllPendingRequest, O: DiscardAllPendingResponse },
    { name: "DiscardPendingBySearch", options: { "authz.method": { role: "EDITOR" } }, I: DiscardPendingBySearchRequest, O: DiscardPendingBySearchResponse },
    { name: "SubmitReview", options: { "authz.method": { role: "EDITOR" } }, I: SubmitReviewRequest, O: SubmitReviewResponse },
    { name: "GetSubmissionStatus", options: { "authz.method": { role: "EDITOR" } }, I: GetSubmissionStatusRequest, O: GetSubmissionStatusResponse },
    { name: "ListSubmissions", options: { "authz.method": { role: "EDITOR" } }, I: ListSubmissionsRequest, O: ListSubmissionsResponse },
    { name: "InitiateStepUpForSubmit", options: { "authz.method": { role: "EDITOR" } }, I: InitiateStepUpForSubmitRequest, O: InitiateStepUpForSubmitResponse },
    { name: "GetLatestSubmission", options: { "authz.method": { role: "EDITOR" } }, I: GetLatestSubmissionRequest, O: GetLatestSubmissionResponse },
    { name: "SearchSubmissions", options: { "authz.method": { role: "EDITOR" } }, I: SearchSubmissionsRequest, O: SearchSubmissionsResponse },
    { name: "SearchSubmissionsByAdmin", options: { "authz.method": { role: "VIEWER" } }, I: SearchSubmissionsByAdminRequest, O: SearchSubmissionsByAdminResponse }
]);
